export const SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS';
